var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section",attrs:{"id":"labs"}},[_c('h2',{staticClass:"title title-section caps lean"},[_vm._v("Blat . Labs")]),_c('div',{staticClass:"feed"},_vm._l((_vm.posts.slice(0, _vm.limit)),function(work){return _c('LabButton',{key:work.id,ref:`btn-${work.id}`,refInFor:true,attrs:{"post":work}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }